import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CursorFollower from "../components/ui/CursorFollower";


// 🧱 Layouts
import AppLayout from "../components/layouts/app/index";

// 💫 Loader
import Loading from "../components/loading";
// import AdminLayout from "../components/layouts/admindashboard";
// import AuthLayout from "../components/layouts/auth/AuthLayout";
// import RouteGuard from "../guards/authguard";
// import { RoleGuard } from "../guards/RoleGuard";
// import { AdminProvider } from "../context/AdminContext";
// import { UserProvider } from "../context/UserContext";
// import UserLayout from "../components/layouts/userdashboard";
import { ScrollToTop } from "../components/ui/ScrollToTop";
const UnauthorizedPage = lazy(() => import("../pages/UnauthorizedPage"));

/* =============================
   🔐 AUTH
============================= */
// const LoginPage = lazy(() => import("../pages/auth/LoginPage"));
// const RegisterPage = lazy(() => import("../pages/auth/RegisterPage"));
// const ForgotPasswordPage = lazy(() => import("../pages/auth/ForgotPasswordPage"));
// const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPasswordPage"));
// const VerifyCodePage = lazy(() => import("../pages/auth/VerifyCodePage"));

/* =============================
   🌍 PAGES PUBLIQUES
============================= */
const HomePage = lazy(() => import("../pages/app/home"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));
const AccountDisabledPage = lazy(() => import("../pages/account/disabled/index"));
const ContactPage = lazy(() => import("../pages/app/contact/index"));
const PublicBoutiquePage = lazy(() => import("../pages/app/boutique/index"));
const PublicBoutiqueDetailPage = lazy(() => import("../pages/app/boutique/show/inndex"));


/* =============================
   🧭 PAGES DASHBOARD ADMIN
============================= */
const DashboardHomePage = lazy(() => import("../pages/admindashboard/home/index"));




/* =============================
   🚀 ROUTEUR PRINCIPAL
============================= */
const AppRouter: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* ===================== Authentification ===================== */}

          {/* <Route element={<RouteGuard isAuth />}>
            <Route element={<AuthLayout />}>
              <Route path="/auth/login" element={<Suspense fallback={<Loading />}><LoginPage /></Suspense>} />
              <Route path="/auth/register" element={<Suspense fallback={<Loading />}><RegisterPage /></Suspense>} />
              <Route path="/auth/forgot-password" element={<Suspense fallback={<Loading />}><ForgotPasswordPage /></Suspense>} />
              <Route path="/auth/reset-password" element={<Suspense fallback={<Loading />}><ResetPasswordPage /></Suspense>} />
              <Route path="/auth/verify-code" element={<Suspense fallback={<Loading />}><VerifyCodePage /></Suspense>} />
            </Route>
          </Route> */}


          {/* ===================== PUBLIC===================== */}
          <Route element={<AppLayout />}>
            <Route path="/" element={<Suspense fallback={<Loading />}><HomePage /></Suspense>} />
            <Route path="/account-disabled" element={<Suspense fallback={<Loading />}><AccountDisabledPage /></Suspense>} />
            <Route path="/contact" element={<Suspense fallback={<Loading />}><ContactPage /></Suspense>} />
            <Route path="/boutique" element={<Suspense fallback={<Loading />}><PublicBoutiquePage /></Suspense>} />
            <Route path="/boutique/:id" element={<Suspense fallback={<Loading />}><PublicBoutiqueDetailPage /></Suspense>} />

          </Route>


          {/* ===================== DASHBOARD USER ===================== */}
          {/* <Route element={<RouteGuard isPrivate />}>
            <Route element={<RoleGuard roles={["user"]} />}>
              <Route element={<UserProvider><UserLayout /></UserProvider>}>

                <Route path="/user/dashboard/home" element={<Suspense fallback={<Loading />}><UserDashboardHomePage /></Suspense>} />
               
              </Route>
            </Route>
          </Route> */}


          {/* ===================== DASHBOARD ADMIN ===================== */}
          {/* <Route element={<RouteGuard isPrivate />}>
            <Route element={<RoleGuard roles={["admin", "platform_admin"]} />}>
              <Route
                element={
                  <AdminProvider>
                    <AdminLayout />
                  </AdminProvider>
                }
              >
                <Route path="/admin/dashboard/home" element={<Suspense fallback={<Loading />}><DashboardHomePage /></Suspense>} />

              </Route>
            </Route>
          </Route> */}

          {/* ===================== 404 ===================== */}
          <Route path="*" element={<Suspense fallback={<Loading />}><NotFoundPage /></Suspense>} />
          <Route path="/unauthorized" element={<Suspense fallback={<Loading />}><UnauthorizedPage /></Suspense>} />
        </Routes>
      </BrowserRouter >
      <CursorFollower />

    </ >
  );
};

export default AppRouter;
